import React from "react";
import { Modal } from "components";
import { AICC_LANGUAGE_STATUS, AiccLanguageStatus } from "constants/aiccLanguage";
import { LEAVE_CONFIRMATION } from "constants/common";
import styles from "./LearningAssets.module.scss";
import { REVERT_ON_EDIT_OK_TEXT, REVERT_ON_EDIT_TITLE, renderRevertOnEditContent } from "../LanguageManagement/configs";

interface ConfirmProps {
  title: string;
  content: React.ReactNode;
  okText: string;
}

const confirm = (props: ConfirmProps): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      ...props,
      cancelText: "Cancel",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });

export const skipLearningAssetConfirm = () => Promise.resolve(true);

export function confirmDiscardLearningAssetEdit() {
  return confirm({ title: "Confirm", content: LEAVE_CONFIRMATION, okText: "OK" });
}

export function confirmSaveLearningAsset(status: AiccLanguageStatus) {
  if (status === AICC_LANGUAGE_STATUS.publishReady) {
    return confirm({
      title: REVERT_ON_EDIT_TITLE,
      content: renderRevertOnEditContent(),
      okText: REVERT_ON_EDIT_OK_TEXT,
    });
  }

  return confirm({
    title: "Confirm",
    content: <div className={styles.confirmContent}>Are you sure you want to proceed with this edit?</div>,
    okText: "Save",
  });
}

export function confirmUploadLearningAsset(status: AiccLanguageStatus) {
  return status === AICC_LANGUAGE_STATUS.publishReady
    ? confirmSaveLearningAsset(status)
    : confirmOverwriteLearningAsset();
}

export function confirmOverwriteLearningAsset() {
  return confirm({
    title: "Are you sure?",
    content: (
      <div className={styles.confirmContent}>This will completely overwrite all existing records for this asset.</div>
    ),
    okText: "Yes, Overwrite",
  });
}
